import { Dialog, AppBar, DialogActions, Button, WithStyles, createStyles, Theme, withStyles, DialogContent, Typography, Toolbar } from '@material-ui/core';
import { DeltaXMLColors } from './styling/DeltaColors';

const styles = (theme: Theme) =>
  createStyles({
  });

export interface DeleteAccountProps extends WithStyles<typeof styles> {
  open: boolean;
  handleClose: () => void;
}

const contentWrapper = {
  margin: '40px 16px',
}

function DeleteAccountDialog(props: DeleteAccountProps) {
  const { classes, open, handleClose } = props;

  return (
    <div style={contentWrapper}>
      <Dialog open={open} onClose={() => { handleClose() }}>
        <AppBar position="static">
        <Toolbar>
          <Typography variant="h4">Delete Account</Typography>
        </Toolbar>
        </AppBar>
        <br />
        <DialogContent>
          <Typography variant="body1" color="textSecondary">If you would like to delete your account, please contact us at:</Typography>
          <Typography variant="body1"><a style={{color: DeltaXMLColors.FOUNTAIN_BLUE}} href="mailto:support@deltaxignia.com?subject=Delete DeltaXignia Account">support@deltaxignia.com</a></Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={() => handleClose()}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
};

export default withStyles(styles)(DeleteAccountDialog);